export default __webpack_public_path__ + "static/media/charnierepercee.7c38bd98.svg";